import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { SupporterMessage } from './SupporterMessage.js';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { EndOfListMessage } from './EndOfListMessage.js';
import { FeatureShutOffMessage } from './FeatureShutOffMessage.js';
import { Pagination } from './pagination.js';


export const SupporterMessageList = createReactClass({
    propTypes: {
        page: PropTypes.number.isRequired,
        data: PropTypes.object,
        challengeId: PropTypes.string,
        changeURL: PropTypes.func,
    },

    mixins: [PureRenderMixin],

    render: function () {
        const props = this.props;
        const data = props.data;

        if (!data || parseInt(data.totalSupporters) === -1) {
            return <FeatureShutOffMessage />;
        }

        const showNextButton = (data.supporters.length == window.DC_DEFAULT_PER_PAGE);

        if (data.supporters.length == 0) {
            return (
                <div className="tab-contents supporters" aria-live="polite" aria-atomic="true">
                    <EndOfListMessage />
                </div>
            );
        }

        return (
            <div className="tab-contents supporters" aria-live="polite" aria-atomic="true">

                <ol className="activity">
                    {data.supporters.map(supporter =>
                        <SupporterMessage message={supporter}
                            challengeId={props.challengeId} key={supporter.proposalMessageId} />)}
                </ol>
                <Pagination page={props.page} showNextButton={showNextButton}
                    simplePagination={true} changeURL={props.changeURL} />
            </div>
        );
    },

});
